import PublicHeader from "../components/PublicHeader";
import PublicFooter from "../components/PublicFooter";
import { MapPin, Mail, Phone, Globe, Clock } from "lucide-react";

export default function Contact() {
    return (
        <div className="min-h-screen flex flex-col">
            <PublicHeader />

            <section className="bg-[#0F172A] text-white">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Get in Touch</div>
                    <h1 className="font-display text-4xl lg:text-6xl font-bold tracking-tight max-w-4xl">STMF Association — Surat Texmac Federation</h1>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24 grid md:grid-cols-12 gap-12">
                <div className="md:col-span-7">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Office</div>
                    <h2 className="font-display text-3xl font-bold text-[#0F172A] mb-10 leading-tight">Visit, call or write to us.</h2>

                    <div className="space-y-px bg-[#E2E8F0] border border-[#E2E8F0]" data-testid="contact-info">
                        <Row icon={MapPin} label="Address" value="Surat, Gujarat, India" />
                        <Row icon={Phone} label="Phone" value="+91 98765 43210" />
                        <Row icon={Mail} label="Email" value="info@stmfindia.com" />
                        <Row icon={Globe} label="Website" value="stmfindia.com" />
                        <Row icon={Clock} label="Office Hours" value="Monday to Saturday · 10:00 AM – 6:00 PM" />
                    </div>
                </div>

                <div className="md:col-span-5">
                    <div className="bg-[#0F172A] text-white p-10 h-full flex flex-col">
                        <div className="font-mono text-xs text-[#D4AF37] mb-4">FOR MEMBERSHIP ENQUIRIES</div>
                        <h3 className="font-display text-2xl font-bold mb-6 leading-tight">Direct your application to the Membership Committee.</h3>
                        <p className="text-white/70 text-sm leading-relaxed mb-8">
                            The fastest route to becoming a verified STMF member is through our online application form. Submissions are typically reviewed within 7 business days.
                        </p>
                        <a href="/apply" data-testid="contact-cta-apply" className="mt-auto inline-flex items-center gap-3 px-6 py-4 bg-[#D4AF37] text-[#0F172A] text-sm font-semibold uppercase tracking-[0.08em] hover:bg-[#B4952D] transition-colors w-fit">
                            Start Application <span>→</span>
                        </a>
                    </div>
                </div>
            </section>

            <PublicFooter />
        </div>
    );
}

function Row({ icon: Icon, label, value }) {
    return (
        <div className="bg-white p-6 flex items-center gap-5">
            <div className="w-11 h-11 bg-[#F8F9FA] text-[#0F172A] flex items-center justify-center shrink-0"><Icon className="w-5 h-5" /></div>
            <div>
                <div className="text-xs uppercase tracking-[0.12em] text-[#64748B] mb-0.5">{label}</div>
                <div className="text-[#0F172A] font-medium">{value}</div>
            </div>
        </div>
    );
}
